"use strict";

export function initInScope($scope) {
    $scope.find('[data-toggle="tooltip"]').tooltip();

    if((matchMedia('(max-width: 767px)').matches)) {
        let table = $scope.find('.wysiwyg table');

        table.removeAttr('cellspacing').removeAttr('cellpadding').removeAttr('border').removeAttr('width');
        table.wrap('<div class="table-responsive"></div>');
    }

    if(_config.showSproofModal) {
        $('#sproofModal').modal('show');
    }
}
